import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Link, CardContent, Grid, Rating, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { APP_ROUTES } from '../../../../../constants/app-routes';
import * as VenueActions from '../../../../../core/venues/action';
import { VENUE_STATUS } from '../../../../../constants/venue-status';
import { CustomButton } from '../../../../../components';

function PendingCard({ venue }) {
  const dispatch = useDispatch();
  const CustomizedSwal = withReactContent(Swal);

  const changeStatus = (newStatus) => {
    console.log(`Changing status to: ${newStatus}`);
    // the console log above is returning "Changing status to: approved" when clicking the comfirm button
    // however, the status isn't changing and the venue is not being approved
    const updateRequest = { ...venue, status: newStatus };
    dispatch(VenueActions.updateVenue(updateRequest));
  };

  const getConfirmationModal = (status) => {
    console.log(`Confirmation modal for status: ${status}`);
    CustomizedSwal.fire({
      title: <strong>{venue.name}</strong>,
      text: `Do you want to ${status === VENUE_STATUS.APPROVED ? 'approve' : 'deny'} this venue?`,
      confirmButtonText: 'Confirm',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        changeStatus(status);
      }
    });
  };

  const handleApprove = () => {
    console.log('Approve button clicked');
    getConfirmationModal(VENUE_STATUS.APPROVED);
  };

  const handleDeny = () => {
    getConfirmationModal(VENUE_STATUS.DENIED);
  };
  const navigateToDetails = (venueId = null) => {
    if (venueId === undefined) return '';
    return APP_ROUTES?.VENUE_PUBLIC_PROFILE.replace(':venueId', venueId);
  };

  return (
    <Grid container mb={2}>
      {/* <Grid item xs={3}>
        <Card>
          {vendor?.image && <img src={vendor?.image} alt="Vendor profile" />}
          <CardContent>
            <Typography variant="body1" fontWeight="bold">
              {vendor?.name}
            </Typography>
            <Typography>Contact: {contact?.name}</Typography>
            <Typography>{contact?.phone_number}</Typography>
            <Typography>{contact?.email}</Typography>
            <Typography>Est. {new Date(vendor?.created_at).getFullYear()}</Typography>
          </CardContent>
        </Card>
      </Grid> */}
      <Grid item xs={12} px={4}>
        <Box>
          <Typography variant="h6" fontWeight="bold">
            <Link href={navigateToDetails(venue?.id)}>{venue?.name}</Link>
          </Typography>
          <Grid item xs={12}>
            <div style={{ display: 'flex' }}>
              <div style={{ flexDirection: 'column' }}>
                <Typography variant="body1" fontWeight="bold">
                  Street Address:
                </Typography>
              </div>
              <div style={{ flexDirection: 'column' }}>
                <Typography color="#0997BA"> {venue?.business_address}</Typography>
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ flexDirection: 'column' }}>
                <Typography variant="body1" fontWeight="bold">
                  Website:
                </Typography>
              </div>
              <div style={{ flexDirection: 'column' }}>
                <Typography color="#0997BA"> {venue?.website}</Typography>
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ flexDirection: 'column' }}>
                <Typography variant="body1" fontWeight="bold">
                  Business Type:
                </Typography>
              </div>
              <div style={{ flexDirection: 'column' }}>
                <Typography> {venue?.business_type}</Typography>
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ flexDirection: 'column' }}>
                <Typography variant="body1" fontWeight="bold">
                  Business Number:
                </Typography>
              </div>
              <div style={{ flexDirection: 'column' }}>
                <Typography> {venue?.business_number}</Typography>
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ flexDirection: 'column' }}>
                <Typography variant="body1" fontWeight="bold">
                  EIN:
                </Typography>
              </div>
              <div style={{ flexDirection: 'column' }}>
                <Typography> {venue?.business_EIN}</Typography>
              </div>
            </div>
          </Grid>
        </Box>
        <Box
          my={2}
          mx={14}
          columnGap={2}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CustomButton variant="contained" onClick={handleApprove}>
            Approve
          </CustomButton>
          <CustomButton variant="outlined" onClick={handleDeny}>
            Deny
          </CustomButton>
        </Box>
      </Grid>
    </Grid>
  );
}

PendingCard.propTypes = {
  venue: PropTypes.instanceOf(Object).isRequired,
};

export default PendingCard;
